<template>
  <div></div>
</template>
<script>

export default {
  data: () => ({
  }),
  created() {
    var lp = require('./it.json')
    window.watsonAssistantChatOptions = {
      integrationID: "edd1951a-3763-4551-b61a-8e6a26d5f2aa",
      region: "eu-de",
      serviceInstanceID: "066bb686-96c5-458d-93c4-8a638c4eded6",
      carbonTheme: 'g10',
      onLoad: function(instance) {
        instance.updateCSSVariables({
          // 'BASE-font-family': '"Times New Roman", Times, serif',
          'BASE-width': '400px',
          '$interactive-01': '#4caf50'
  /*         '$active-primary': '#009900',
          '$focus': '#008000',
          '$hover-primary': '#00ff00',
          '$interactive-01': '#008000' */
        });
        instance.updateLanguagePack(lp);
        instance.updateLocale('it').then(function() {
          instance.render();
  /*         const button = document.querySelector('.WACLauncher__Button');
          if (button) {
            button.left='32px'
            button.right='auto'
          }  */
        });
      }
    };    
    setTimeout(function(){const t=document.createElement('script');t.src="https://web-chat.global.assistant.watson.appdomain.cloud/versions/" + (window.watsonAssistantChatOptions.clientVersion || 'latest') + "/WatsonAssistantChatEntry.js";document.head.appendChild(t);});
  }
}
</script>

<style>
  .WACLauncher__ButtonContainer {
/*     left: 15px !important;
    right: auto !important;
    top: auto !important;    
    bottom:100px !important; */
    top: 2px !important;
    bottom: auto !important;
    right: 5px !important;
    left: auto !important;
  }
  #WACWidget {
/*     left: 15px !important;
    bottom: 10px !important; */
    top: 10px !important;
    right: 5px !important;
    left: auto !important;
    bottom: auto !important;
  }
</style>
